define("shared/models/th-post", ["exports", "@ember/object"], function (_exports, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/object"eaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  class DynamoThreadsPost extends _object.default {
    constructor(attrs) {
      const attrsCopy = {
        ...attrs
      };
      super();
      _defineProperty(this, "id", void 0);
      _defineProperty(this, "createdAtUnix", void 0);
      _defineProperty(this, "url", void 0);
      _defineProperty(this, "imageUrl", void 0);
      _defineProperty(this, "text", void 0);
      _defineProperty(this, "shares", void 0);
      _defineProperty(this, "laterPostId", void 0);
      _defineProperty(this, "shortcode", void 0);
      _defineProperty(this, "permalink", void 0);
      _defineProperty(this, "mediaType", void 0);
      _defineProperty(this, "mediaId", void 0);
      _defineProperty(this, "views", void 0);
      _defineProperty(this, "reposts", void 0);
      _defineProperty(this, "likes", void 0);
      _defineProperty(this, "replies", void 0);
      _defineProperty(this, "quotes", void 0);
      _defineProperty(this, "createdTime", void 0);
      _defineProperty(this, "engagement", void 0);
      _defineProperty(this, "engagements", void 0);
      _defineProperty(this, "socialProfile", void 0);
      _defineProperty(this, "scheduledPost", void 0);
      this.id = attrsCopy.id;
      this.createdAtUnix = attrsCopy.createdAtUnix;
      this.url = attrsCopy.url;
      this.imageUrl = attrsCopy.imageUrl;
      this.text = attrsCopy.text;
      this.shares = attrsCopy.shares;
      this.laterPostId = attrsCopy.laterPostId;
      this.shortcode = attrsCopy.shortcode;
      this.permalink = attrsCopy.permalink;
      this.mediaType = attrsCopy.mediaType;
      this.mediaId = attrsCopy.mediaId;
      this.views = attrsCopy.views;
      this.reposts = attrsCopy.reposts;
      this.likes = attrsCopy.likes;
      this.replies = attrsCopy.replies;
      this.quotes = attrsCopy.quotes;
      this.createdTime = attrsCopy.createdTime;
      this.engagement = attrsCopy.engagement;
      this.engagements = attrsCopy.engagements;
      this.socialProfile = attrsCopy.socialProfile;
      this.scheduledPost = attrs.scheduledPost;
    }
  }
  _exports.default = DynamoThreadsPost;
});